module.exports = __webpack_public_path__ + "img/11-W60.641be8f.png";